import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ListLink from './ListLink';

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      target: PropTypes.string,
    })
  ),
  settings: PropTypes.shape({
    rows: PropTypes.number,
  }),
};

function LinksListSection({ items, settings }) {
  const { rows } = settings;

  return (
    <Root rows={rows}>
      {items.map(({ slug, title, target }) => (
        <ListLink
          key={slug}
          slug={slug}
          target={target}
          title={title}
          settings={{
            rows,
          }}
        />
      ))}
    </Root>
  );
}

LinksListSection.propTypes = propTypes;

export default LinksListSection;

const Root = styled.ul`
  list-style-type: none;

  li:first-child {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }

  li:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  ${({ rows }) =>
    rows &&
    rows > 1 &&
    `
    display: flex;
    flex-wrap: wrap;
  `}
`;
